import clickOutside from 'click-outside'
import { Storefy } from 'storefy'

export default megaMenu = ({ container }) => {
  const store = Storefy((store) => {
    store.on('@init', {
      headerEl: document.getElementById(container),
      mobileBtnEl: document.getElementById('js-mobile-nav-open'),
      mobileCloseBtnEl: document.getElementById('js-mobile-nav-close'),
      activeID: null,
      activePanel: null,
    })

    store.on('setActive', ({ activeID, activePanel }, panelID) => {
      const panel = document.querySelector(`[data-menu-panel="${panelID}"]`)
      const panelFirst = document.querySelector(`[data-menu-panel="0"]`)
      const button = document.querySelector(`[data-menu-item="${panelID}"]`)
      const headerContainerEl = document.getElementById('js-header-container')

      if (headerContainerEl && window.innerWidth >= 1061) {
        const rect = headerContainerEl.getBoundingClientRect()
        panel.style.top = `${rect.height}px`
      }

      panel.classList.add('nav-panel--active')
      panel.setAttribute('aria-hidden', 'false')

      if (button) {
        button.setAttribute('aria-expanded', 'true')
      }

      if (panelID === 0) {
        store.get('mobileBtnEl').setAttribute('aria-expanded', 'true')
        panel.classList.add('m:overflow-y-auto')
      }

      if (panelID > 0) {
        // fixes a bug on screens with a small height
        panelFirst.scroll(0, 0)
        panelFirst.classList.remove('m:overflow-y-auto')
        panelFirst.classList.add('m:overflow-hidden')
      }

      document.body.classList.add('element-lock')

      return { activeID: panelID, activePanel: panel }
    })

    store.on('setInactive', ({ activeID, activePanel }) => {
      var activePanel = store.get('activePanel')
      const current = store.get('activeID')
      const button = document.querySelector(`[data-menu-item="${activeID}"]`)
      const panelFirst = document.querySelector(`[data-menu-panel="0"]`)

      if (!activePanel) {
        return
      }

      panelFirst.classList.remove('m:overflow-hidden')
      activePanel.classList.remove('nav-panel--active')
      activePanel.setAttribute('aria-hidden', 'true')
      activePanel.style.top = `0px`

      document.body.classList.remove('element-lock')

      if (button) {
        button.setAttribute('aria-expanded', 'false')
      }

      if (activeID === 0) {
        store.get('mobileBtnEl').setAttribute('aria-expanded', 'false')
      }

      return {
        activeID: 0,
        activePanel: document.querySelector(`[data-menu-panel="0"]`),
      }
    })
  })

  const headerEl = store.get('headerEl')

  if (!headerEl) return

  // primary nav click handler
  headerEl.addEventListener('click', (e) => {
    const menuItem = e?.target
    const menuItemID = menuItem?.dataset?.menuItem
    const previousMenuItemID = store.get('activeID')

    if (menuItemID === previousMenuItemID) {
      store.dispatch('setInactive')
      return
    }

    if (menuItemID) {
      e.preventDefault()

      // close the mega menu items, keep the last active panel on mobile
      if (window.outerWidth >= 1060) {
        store.dispatch('setInactive')
      }

      store.dispatch('setActive', menuItemID)
      return
    }

    if (menuItem.classList.contains('js-menu-close')) {
      store.dispatch('setInactive')
      return
    }
  })

  // handle resize events
  window.addEventListener('resize', () => {
    if (window.outerWidth >= 1060) {
      store.dispatch('setInactive')
    }
  })

  // handle outside clicks
  clickOutside(headerEl, ({ target }) => {
    if (target.nodeName === 'A' || target.nodeName === 'BUTTON') {
      return
    }

    store.dispatch('setInactive')
  })

  // mobile click handlers
  store
    .get('mobileBtnEl')
    .addEventListener('click', () => store.dispatch('setActive', 0))

  store
    .get('mobileCloseBtnEl')
    .addEventListener('click', () => store.dispatch('setInactive'))
}
